import { DateTime } from "luxon";
import React from "react";
import { PAGE_SIZE_OPTIONS } from "../../../Constants/FieldOptions";

function OrgActivitiesListDesktop(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onSelectSessionForDeletion,
  } = props;

  function secondsAndMinutes(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    if (hours > 0) {
      return `${hours} hr${hours > 1 ? "s" : ""}`;
    } else if (minutes > 0) {
      return `${minutes}:${
        remainingSeconds < 10 ? "0" : ""
      }${remainingSeconds} min`;
    } else {
      return `0${remainingSeconds}:sec`;
    }
  }

  return (
    <div class="b-table">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>Time</th>

              <th>Type</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {listData &&
              listData.map(function (item, i) {
                return (
                  <tr>
                    <td  >{item.name}</td>
                    <td data-label="Name">{secondsAndMinutes(item.time)}</td>
                    <td data-label="Session Type">{item.activityType}</td>
                    <td data-label="Session Type">
                      {DateTime.fromSeconds(item.created).toLocaleString(
                        DateTime.DATETIME_MED
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <div class="columns">
          <div class="column is-half">
            <span class="select">
              <select
                class={`input has-text-grey-light`}
                name="pageSize"
                onChange={(e) => setPageSize(parseInt(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map(function (option, i) {
                  return (
                    <option
                      selected={pageSize === option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div class="column is-half has-text-right">
            {previousCursors.length > 0 && (
              <button class="button" onClick={onPreviousClicked}>
                Previous
              </button>
            )}
            {listData.hasNextPage && (
              <>
                <button class="button" onClick={onNextClicked}>
                  Next
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrgActivitiesListDesktop;
